export default function openPriceTableSingleLine() {
  // 1. Check if the body has class 'single-offer'
  if (document.body.classList.contains("single-offer")) {
    // 2. Get the current URL hash (e.g. #1-1)
    let hash = window.location.hash;
    if (hash) {
      // Remove the '#' from the hash
      hash = hash.substring(1);

      // 3. Regex to allow digits and optional dashes (e.g. 1, 1-1, 2-3, etc.)
      const numericRegex = /^[0-9-]+$/;

      // Check if the hash matches our pattern
      if (numericRegex.test(hash)) {
        // 4. Check if an element with that ID exists
        const targetElement = document.getElementById(hash);
        if (targetElement) {
          // Trigger click on that element after 300ms
          setTimeout(function () {
            targetElement.click();
          }, 500);
        }
      }
    }
  }
}
